import { useEffect } from 'react';
import { Dropdown, DefaultDropdownProps, useFormContext } from 'framework/form';
import { get } from 'lodash';
import { ExpectedStructureType, ProjectTeamType } from 'domain/shared/newProject';
import { usePositionService } from 'domain/shared/employee';
import { useTechnologyService } from 'domain/shared/career';
import { useAsyncValue } from 'framework/utils';
import { PROJECT_MEMBERSHIP_ROLES, ProjectMembershipRole } from '../../../core/constants';

interface TeamSlotDropdownProps extends DefaultDropdownProps {
  source: string;
  projectIdSource: string;
  team?: ProjectTeamType | { isNeedCreateTeam: boolean; expectedStructure: [] };
}

const TeamSlotDropdown = ({ source, projectIdSource, team, ...props }: TeamSlotDropdownProps) => {
  const { data: formData, onChangeCallback } = useFormContext();

  const { findAll: findPos } = usePositionService();
  const { findAll: findTech } = useTechnologyService();
  const positions = useAsyncValue(() => findPos());
  const technologies = useAsyncValue(() => findTech());
  const selectedSlot = team?.expectedStructure?.find((s: ExpectedStructureType) => s.id === get(formData, source));

  const options = team?.expectedStructure?.map((teamSlot: any) => {
    const position = positions?.find((pos: any) => pos.id === teamSlot.positionId);
    const technology = teamSlot.technologyId
      ? technologies?.find((tech: any) => tech.id === teamSlot.technologyId)
      : null;

    let label = technology ? `${technology.name} ` : '';
    if (position) {
      label += position.name;
    }
    if (teamSlot.competencyLevel) {
      label += ` (${teamSlot.competencyLevel})`;
    }
    const roleValue: ProjectMembershipRole | null | undefined = teamSlot.requiredRole;

    if (roleValue != null) {
      const role = PROJECT_MEMBERSHIP_ROLES[roleValue];
      if (role) {
        label += ` - ${role}`;
      }
    }

    return {
      value: teamSlot.id,
      label,
    };
  });

  useEffect(() => {
    if (formData?.membershipRole !== selectedSlot?.requiredRole) {
      onChangeCallback?.({ membershipRole: selectedSlot?.requiredRole }, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSlot]);

  return <Dropdown source={source} options={options} {...props} placeholder="Slot" />;
};

export default TeamSlotDropdown;
